/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "claimRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "compoundFreq",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "compoundRewardsTimer",
        outputs: [
            {
                internalType: "uint256",
                name: "_timer",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "getDepositInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "_stake",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_rewards",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "salt",
                type: "uint256",
            },
        ],
        name: "getWalletByShare",
        outputs: [
            {
                internalType: "address",
                name: "wallet",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_initSupply",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_maxSupply",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_rewardsPerSec",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_compoundFreq",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "maxSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsPerSec",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakeRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalShares",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class BTLYV1__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
BTLYV1__factory.bytecode = _bytecode;
BTLYV1__factory.abi = _abi;
